import classNames from "clsx";

export type SpinnerProps = {
  /** Size and colour come from the classes; defaults to 5 units, current colour. */
  className?: string;
  /** Read out by assistive tech; leave empty when a parent already says so. */
  label?: string;
};

/**
 * A spinning ring in the current text colour, for anything in progress.
 */
export default function Spinner({ className, label }: SpinnerProps) {
  return (
    <svg
      className={classNames("animate-spin", className ?? "h-5 w-5")}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      data-testid="progress-spinner"
      role={label ? "status" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
}
